export const TIKTOK_PIXEL_ID = 'C0DEUO9F9F46QGH8G00G';
